import validate from "/usr/src/app/node_modules/.pnpm/nuxt@3.17.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@18.19.110_db0@0.3.2_eslint_t2ykcx5otu5g34mebxjltn3ldu/node_modules/nuxt/dist/pages/runtime/validate.js";
import trailing_45slash_45global from "/usr/src/app/middleware/trailing-slash.global.ts";
import manifest_45route_45rule from "/usr/src/app/node_modules/.pnpm/nuxt@3.17.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@18.19.110_db0@0.3.2_eslint_t2ykcx5otu5g34mebxjltn3ldu/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-guard": () => import("/usr/src/app/middleware/authGuard.ts")
}